import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const getComponent = (url) => {
  return () => import(`@page/${url}.vue`);
};

// 解决重复路由点击问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const router = new Router({
  mode: "history",
  routes: [{
      name: "home",
      path: "/",
      meta: {
        disableCheckUser: true,
        title: "首页"
      },
      component: getComponent("home/index")
    },
    {
      name: "visa",
      path: "/visa",
      meta: {
        disableCheckUser: true,
        title: "签证"
      },
      component: getComponent("visa/index"),
    },
    {
      name: "faq",
      path: "/faq",
      meta: {
        disableCheckUser: true,
        title: "常见问题"
      },
      component: getComponent("visa/faq"),
    },
    {
      name: "faq_detail",
      path: "/faq_detail",
      meta: {
        disableCheckUser: true,
        title: "常见问题"
      },
      component: getComponent("visa/faq_detail"),
    },
    // {
    //   name: "visa_list",
    //   path: "/visa_list",
    //   meta: {
    //     disableCheckUser: true,
    //     title: "签证列表"
    //   },
    //   component: getComponent("visa/list"),
    // },
    {
      name: "visa_list",
      path: "/visa_list",
      meta: {
        disableCheckUser: true,
        headerIsSticky: true,
        title: "签证列表"
      },
      component: getComponent("visa/list2"),
    },
    // {
    //   name: "visa_detail",
    //   path: "/visa_detail",
    //   meta: {
    //     disableCheckUser: true,
    //     title: "签证详情"
    //   },
    //   component: getComponent("visa/detail"),
    // },
    {
      name: "order_add",
      path: "/order_add",
      meta: {
        title: "添加订单"
      },
      component: getComponent("order/add"),
    },
    // 旧版订单支付
    {
      name: "order_pay",
      path: "/order_pay",
      meta: {
        title: "订单支付"
      },
      component: getComponent("order/pay"),
    },
    // 新版订单支付
    {
      name: "order_payment",
      path: "/order_payment",
      meta: {
        title: "订单支付"
      },
      component: getComponent("orderPro/payment"),
    },
    // 新版订单中心
    {
      name: "orderCenter",
      path: "/orderCenter",
      meta: {
        title: "订单中心"
      },
      component: getComponent("orderPro/orderCenter"),
    },
    // 新版订单详情

    {
      name: "orderDetail",
      path: "/orderDetail",
      meta: {
        title: "订单详情"
      },
      component: getComponent("orderPro/orderDetail"),
    },
    {
      name: "order_list",
      path: "/order_list",
      meta: {
        title: "签证订单列表"
      },
      component: getComponent("order/list"),
    },
    {
      name: "order_detail",
      path: "/order_detail",
      meta: {
        title: "订单详情"
      },
      component: getComponent("order/detail"),
    },
    {
      name: "login",
      path: "/login",
      meta: {
        hasHeader: false,
        hasFooter: false,
        disableCheckUser: true,
        title: "登录"
      },
      component: getComponent("user/login"),
    },
    {
      name: "register",
      path: "/register",
      meta: {
        disableCheckUser: true,
        title: "注册"
      },
      component: getComponent("user/register"),
    },
    {
      name: 'update_pwd',
      path: '/update_pwd',
      meta: {
        title: "修改密码"
      },
      component: getComponent("user/update_pwd")
    },
    {
      name: 'update_info',
      path: '/update_info',
      meta: {
        title: "修改资料"
      },
      component: getComponent("user/update_info")
    },
    {
      name: "user",
      path: "/user",
      meta: {
        title: "用户中心"
      },
      component: getComponent("user/index"),
    },
    {
      name: "address",
      path: "/address",
      meta: {
        title: "收件地址"
      },
      component: getComponent("address/list"),
    },
    {
      name: "myuser",
      path: "/myuser",
      meta: {
        title: "我的账户"
      },
      component: getComponent("myuser/list"),
    },
    {
      name: "commission",
      path: "/commission",
      meta: {
        title: "业绩提成"
      },
      component: getComponent("commission/list"),
    },
    {
      name: 'aboutUs',
      path: '/aboutUs',
      meta: {
        disableCheckUser: true,
        title: '关于我们'
      },
      component: getComponent("home/aboutUs")
    },
    {
      name: 'contactUs',
      path: '/contactUs',
      meta: {
        disableCheckUser: true,
        title: '联系我们'
      },
      component: getComponent("home/contactUs")
    },
    {
      name: 'coupon_list',
      path: '/coupon_list',
      meta: {
        title: '优惠券列表'
      },
      component: getComponent("coupon/list")
    },
    {
      name: 'coupon_info',
      path: '/coupon_info',
      meta: {
        title: '优惠券详情'
      },
      component: getComponent("coupon/info")
    },
    {
      name: 'get_coupon',
      path: '/get_coupon',
      meta: {
        title: '领取优惠券'
      },
      component: getComponent("coupon/get")
    },
    {
      name: 'hotel',
      path: '/hotel',
      meta: {
        title: '酒店',
        disableCheckUser: true
      },
      component: getComponent("hotel/index")
    },
    {
      name: 'hotel_list',
      path: '/hotel_list',
      meta: {
        title: '酒店列表',
        disableCheckUser: true
      },
      component: getComponent("hotel/list")
    },
    {
      name: 'hotel_detail',
      path: '/hotel_detail',
      meta: {
        title: '酒店详情',
        disableCheckUser: true
      },
      component: getComponent("hotel/detail")
    },
    {
      name: 'hotel_order',
      path: '/hotel_order',
      meta: {
        title: '酒店订单列表'
      },
      component: getComponent("hotel/order")
    },
    {
      name: 'hotel_order_detail',
      path: '/hotel_order_detail',
      meta: {
        title: '酒店订单详情'
      },
      component: getComponent("hotel/order_detail")
    },
    {
      name: 'hotel_order_add',
      path: '/hotel_order_add',
      meta: {
        title: '添加酒店订单'
      },
      component: getComponent("hotel/order_add")
    },
    {
      name: 'hotel_order_pay',
      path: '/hotel_order_pay',
      meta: {
        title: '支付酒店订单'
      },
      component: getComponent("hotel/pay")
    },
    {
      path: '/travel',
      meta: {
        title: '旅游'
      },
      component: getComponent("travel/travel"),

      children: [{
        name: 'travel',
        path: '',
        meta: {
          title: '旅游',
          disableCheckUser: true,
        },
        component: getComponent("travel/index/index")
      }]
    },
    // ---------------------------------------------
    {
      path: '/tour',
      meta: {
        title: '旅游度假'
      },
      component: getComponent("tour/index"),
      children: [{
          name: 'tour',
          path: '',
          meta: {
            title: '旅游度假',
            disableCheckUser: true,
          },
          component: getComponent("tour/home")
        }, {
          name: 'tour_list',
          path: 'list',
          meta: {
            title: '旅游度假',
            disableCheckUser: true,
          },
          component: getComponent("tour/list")
        }, {
          name: 'tour_add',
          path: 'add',
          meta: {
            title: '添加旅游订单'
          },
          component: getComponent('tour/order/add')
        }, {
          name: 'tour_pay',
          path: 'pay',
          meta: {
            title: '旅游订单支付'
          },
          component: getComponent('tour/order/pay')
        }, {
          name: 'tour_order_list',
          path: 'order_list',
          meta: {
            title: '旅游订单列表'
          },
          component: getComponent('tour/order/list')
        }, {
          name: 'tour_order_detail',
          path: 'order_detail',
          meta: {
            title: '旅游订单详情'
          },
          component: getComponent('tour/order/detail')
        }, {
          path: ':id',
          name: 'tour_detail',
          meta: {
            title: '旅游详情',
            disableCheckUser: true
          },
          component: getComponent("tour/detail")
        },
        {
          name: 'travelCategoryList',
          path: '/travelCategoryList/:category_id',
          meta: {
            title: '旅游产品列表',
            disableCheckUser: true
          },
          component: getComponent("tour/travelCategoryList/index")
        }
      ]
    },
  ],
});

// 全局路由守卫
router.beforeEach((to, from, next) => {
  const {
    title = ''
  } = to.meta;
  document.title = `${title} - 深圳市常顺旅行社有限公司`;
  next();
});

export default router;